var $ = global.$;

var widgets = require('../lib/widgets');
var parser = require('../lib/parser');

module.exports = {
  init: function(){
    this.quickLinksWidget = widgets.getWidget('quickLinksWidget');
    this.$quickLinksHeaderTarget = $('#quickLinksHeader');

    this.cloneQuickLinks();

  },
  cloneQuickLinks: function(){
    var $ql = $('<div class="quick-links" id="quickLinksWidgetClone" data-widget="Quicklinks"></div>').append(this.quickLinksWidget.html);

    $ql.appendTo(this.$quickLinksHeaderTarget);

    parser.parse(this.$quickLinksHeaderTarget);
  }
};



//////////////////
// WEBPACK FOOTER
// ./source/scripts/controllers/home.js
// module id = 266
// module chunks = 0 1